/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Complete_CourseInputs */

const en_player_complete_course = /** @type {(inputs: Player_Complete_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete course`)
};

const ja_player_complete_course = /** @type {(inputs: Player_Complete_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コースを完了`)
};

const fr_player_complete_course = /** @type {(inputs: Player_Complete_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminer le cours`)
};

const de_player_complete_course = /** @type {(inputs: Player_Complete_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurs abschließen`)
};

/**
* | output |
* | --- |
* | "Complete course" |
*
* @param {Player_Complete_CourseInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_complete_course = /** @type {((inputs?: Player_Complete_CourseInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Complete_CourseInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_complete_course(inputs)
	if (locale === "ja") return ja_player_complete_course(inputs)
	if (locale === "fr") return fr_player_complete_course(inputs)
	return de_player_complete_course(inputs)
});